
export const PERTITEL = [
  { 'VALUE': '0',  'TEXT': ''},
  { 'VALUE': '1',  'TEXT': 'Dr.'},
  { 'VALUE': '2',  'TEXT': 'Prof'},
  { 'VALUE': '3',  'TEXT': 'Prof.Dr'},
  { 'VALUE': '4',  'TEXT': 'Prof.Dr.Dr.'},
  { 'VALUE': '5',  'TEXT': 'Dipl.Ing'},
];


export function getPertitel(value) {
  let option = _.find(PERTITEL, ['VALUE', value]);
  return typeof(option) != 'undefined' ? option.TEXT : '';
};


export const ART = [
  { 'VALUE': '0',  'TEXT': ''},
  { 'VALUE': '1',  'TEXT': 'Herr'},
  { 'VALUE': '2',  'TEXT': 'Frau'},
  { 'VALUE': '3',  'TEXT': 'Abteilung'},
  { 'VALUE': '4',  'TEXT': 'Thema'},
];


export function getArt(value) {
  let option = _.find(ART, ['VALUE', value]);
  return typeof(option) != 'undefined' ? option.TEXT : '';
};



// WEBPACK FOOTER //
// ./src/common/user.conf.js